const actions = {
  SET_STATE: 'systemSettings/SET_STATE',
  FETCH_ALL_SYSTEM_SETTINGS: 'systemSettings/FETCH_ALL_SYSTEM_SETTINGS',
  UPDATE_ALL_SYSTEM_SETTINGS: 'systemSettings/UPDATE_ALL_SYSTEM_SETTINGS',
  DELETE_SYSTEM_SETTINGS: 'systemSettings/DELETE_SYSTEM_SETTINGS',
}

export default actions
